/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconMapWest = createReactComponent("outline", "map-west", "IconMapWest", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M9 9l1 6l2 -3.75l2 3.75l1 -6", "key": "svg-1" }]]);

export { IconMapWest as default };
//# sourceMappingURL=IconMapWest.mjs.map
